module.exports = __webpack_public_path__ + "img/logo_dk_top@2x.8a5b0d7d.png";